webpackJsonp([29],{

/***/ 1066:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-summary bgWhite px-1"
  }, [_c('div', {
    staticClass: "wrapper-summary d-flex flex-column"
  }, [_c('p', {
    staticClass: "title-summary"
  }, [_vm._v("Resumen de tu compra")]), _vm._v(" "), _c('section', {
    staticClass: "pt-3 pb-1 px-3 fontS14"
  }, [_c('div', {
    staticClass: "d-flex space-between mb-1"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("SubTotal")]), _vm._v(" "), _c('p', {
    staticClass: "m0"
  }, [_vm._v(" " + _vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.getTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Envío")]), _vm._v(" "), _c('p', {
    staticClass: "m0"
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.shippingCostAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Descuento")]), _vm._v(" "), _c('p', {
    staticClass: "m0"
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm.getClientDiscount))])])]), _vm._v(" "), _c('section', {
    staticClass: "px-3 d-flex space-between fontS16"
  }, [_c('p', [_vm._v("Total")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.total)))])]), _vm._v(" "), _c('section', {
    staticClass: "container-button px-1 flex-95"
  }, [_c('div', {
    staticClass: "d-flex justify-center"
  }, [(_vm.routeName === 'payment') ? _c('button', {
    class: [
      'btn-box',
      'uppercase',
      'btn-responsive',
      {
        'btn-disabled': _vm.invalidOrder
      } ],
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:1px solid " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button",
      "disabled": _vm.invalidOrder
    },
    on: {
      "click": function($event) {
        _vm.makeOrder()
      }
    }
  }, [_vm._v("Pagar")]) : (_vm.routeName === 'buy-car') ? _c('button', {
    class: [
      'btn-box uppercase',
      {
        'btn-disabled': _vm.totalProducts < 1
      } ],
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:1px solid " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button",
      "disabled": _vm.totalProducts < 1
    },
    on: {
      "click": _vm.payAction
    }
  }, [_vm._v("Pasar a caja")]) : _c('button', {
    class: [
      'uppercase',
      'btn-box',
      'btn-responsive',
      {
        'btn-disabled': _vm.invalidPaymentMethod
      } ],
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:1px solid " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button",
      "disabled": _vm.invalidPaymentMethod
    },
    on: {
      "click": function($event) {
        _vm.makeOrder(true)
      }
    }
  }, [_vm._v("Finalizar Compra")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1066),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06fe9f96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_lib__ = __webpack_require__(37);






var payAction = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
		var publicToken, headers, products, salPriceListId, companyId, dataToSend, dataProducts, _ref2, responsePreOrder;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (!this.token) {
							_context.next = 19;
							break;
						}

						publicToken = this.$store.state.publicToken;
						headers = {
							Authorization: 'Bearer ' + publicToken
						};
						products = this.getLocalStorage('product-select');
						salPriceListId = this.getCommerceData.settings.salPriceListId;
						companyId = this.getCommerceData.company.id;
						dataToSend = {};
						dataProducts = products.map(function (item) {
							var product = {
								id: item.id,
								name: item.name,
								description: item.description,
								code: item.code,
								urlImage: item.urlImage,
								priceListId: salPriceListId,
								quantity: item.quantity,
								warehouseId: item.warehouseProduct.warehouseId,
								unitId: item.unitId,
								amount: item.amount,
								weight: item.weight,
								price: item.price
							};
							return product;
						});

						dataToSend.isNotLogged = false;
						dataToSend.companyId = companyId;
						dataToSend.typePreOrder = 2;
						dataToSend.order = {
							orderCode: 0,
							customer: {
								token: this.token
							},
							products: dataProducts,
							makiId: null,
							origin: 'web',
							status: 'Pendiente'
						};
						_context.next = 14;
						return this.$httpShoppyrrunn.post('pre-order', dataToSend, { headers: headers });

					case 14:
						_ref2 = _context.sent;
						responsePreOrder = _ref2.data;

						window.open(responsePreOrder.processUrl, '_self');
						_context.next = 20;
						break;

					case 19:
						this.$router.push({ name: 'login' });

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function payAction() {
		return _ref.apply(this, arguments);
	};
}();

var makeOrder = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(finish) {
		var _this = this;

		var orderId, url, method, headers, body, _ref4, order;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						orderId = getDeeper('id')(this.orderSummaryInfo);
						url = orderId ? 'orders/' + orderId : 'orders';
						method = orderId ? 'patch' : 'post';

						if (!this.token) {
							_context2.next = 16;
							break;
						}

						headers = {
							Authorization: 'Bearer ' + this.token
						};
						body = this.buildBody(finish, orderId);
						_context2.next = 8;
						return this.$httpJapi[method](url, body, { headers: headers });

					case 8:
						_ref4 = _context2.sent;
						order = _ref4.data;

						orderId = order.id || orderId;
						_context2.next = 13;
						return this.getOrderDetails(orderId);

					case 13:
						if (finish) {
							this.$message({
								message: 'Pedido realizado con éxito',
								showClose: true,
								type: 'success'
							});
							setTimeout(function () {
								_this.$router.push({ name: 'order-summary' });
							}, 250);
						} else {
							this.$router.push({ name: 'payment-method' });
						}
						// this.$store.commit('SET_NEW_ADDRESS_DATA', null);
						_context2.next = 17;
						break;

					case 16:
						this.$message({
							message: 'Debe iniciar sesión para realizar el pedido',
							showClose: true,
							type: 'error'
						});

					case 17:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function makeOrder(_x) {
		return _ref3.apply(this, arguments);
	};
}();

var getOrderDetails = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
		var headers, _ref6, response;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						headers = {
							Authorization: 'Bearer ' + this.token
						};
						_context3.next = 3;
						return this.$httpJapi.get('orders/' + id, { headers: headers });

					case 3:
						_ref6 = _context3.sent;
						response = _ref6.data;

						this.$store.commit('SAVE_NEW_ORDER', response);

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function getOrderDetails(_x2) {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getDeeper = __WEBPACK_IMPORTED_MODULE_6__helpers_lib__["a" /* default */].getDeeper;


function total() {
	var totalAmount = this.getTotalAmount - this.getClientDiscount + this.shippingCostAmount;
	return Number(totalAmount.toFixed(2));
}

function getWarehouseId() {
	return this.flagPickUp === 1 ? this.warehouse.id : this.deliveryAddress.id;
}

function getWarehouseName() {
	return this.flagPickUp === 1 ? this.warehouse.name : this.deliveryAddress.name;
}

function customerAddressId() {
	if (this.flagPickUp === 2) {
		return null;
	}
	return this.deliveryAddress ? this.deliveryAddress.id : null;
}

function getBillindData() {
	var _this2 = this;

	if (this.billingData) {
		var fullBilling = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.billingData).every(function (k) {
			return _this2.billingData[k];
		});
		return fullBilling ? this.billingData : null;
	}
	return null;
}

function getWarehouseAddress() {
	return this.flagPickUp === 1 ? 'undefined' : this.deliveryAddress.address;
}

function buildBody(finish, orderId) {
	var flagTax = this.shippingCostObject ? Boolean(this.shippingCostObject.flagTax) : false;
	var tax = this.shippingCostObject ? this.shippingCostObject.tax : 0;
	var taxAmount = this.shippingCostObject ? this.shippingCostObject.taxAmount : 0;
	var body = {
		costShipping: this.shippingCostAmount,
		costShippingFlagTax: flagTax,
		costShippingTax: tax,
		costShippingTaxAmount: taxAmount,
		customerAddressId: this.customerAddressId,
		customerAddress: this.customerAddressId ? null : this.getNewAddressData,
		customerBill: this.getBillindData,
		details: this.getDetails(this.productsSelected, orderId),
		deliveryAddress: this.deliveryAddress,
		discount: this.getClientDiscount,
		flagPickUp: this.flagPickUp,
		responsiblePickUp: this.getResponsibleData,
		subtotal: this.getTotalAmount,
		total: this.total,
		warehouseId: this.getWarehouseId,
		warehouseName: this.getWarehouseName,
		warehouseAddress: this.getWarehouseAddress
	};
	if (this.orderSummaryInfo && this.orderSummaryInfo.flagStatusOrder) {
		body.orderStateId = this.orderSummaryInfo.orderStateId;
		body.flagStatusOrder = finish ? 3 : this.orderSummaryInfo.flagStatusOrder;
		body.wayPaymentId = finish ? this.getWayPayment.wayPayment : null;
		body.bankAccountId = finish ? this.getWayPayment.bankAccountId : null;
	} else {
		body.commerceCode = 'SOLINTHA';
	}
	return body;
}

function getDetails(products, orderId) {
	var _this3 = this;

	return products.map(function (p) {
		var taxes = p.taxes;

		var newTaxes = _this3.setTaxes(taxes);
		var newP = {
			alternateCode: p.alternateCode,
			brandId: getDeeper('warehouseProduct.brandId')(p) || p.brandId,
			brandName: getDeeper('warehouseProduct.brand.name')(p) || p.brandName,
			categoryId: p.categoryId,
			categoryName: getDeeper('category.name')(p) || p.categoryName,
			codeTaxes: taxes[0].code,
			description: p.description,
			discount: p.discount || 0,
			discountPercentage: p.discountPercentage || 0,
			product: {
				id: orderId ? p.productId : p.id,
				taxes: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newTaxes)),
				type: getDeeper('typeInfo.id')(p) || getDeeper('product.type')(p)
			},
			productCode: p.code || p.productCode,
			productId: orderId ? p.productId || p.id : p.id,
			productImage: p.urlImage || p.productImage,
			productName: p.name || p.productName,
			quantity: p.quantity,
			salePrice: p.priceDiscount || p.salePrice,
			stockQuantity: p.stock,
			taxes: newTaxes,
			unit: p.unitSelected,
			unitCode: p.unitSelected.code,
			unitConversion: 1,
			unitId: p.unitSelected.id,
			unitName: p.unitSelected.name,
			unitQuantity: p.quantity,
			warehouseId: _this3.getWarehouseId,
			warehouseName: _this3.getWarehouseName
		};
		return newP;
	});
}

function setTaxes(taxes) {
	var newTaxes = [];
	if (!taxes && taxes.length === 0) {
		newTaxes[0] = {
			code: '01',
			codeTable: 'TABLE17',
			codePercentage: '01',
			flagSales: true,
			flagPurchases: false
		};
	} else {
		var tax = taxes[0];
		newTaxes[0] = {
			code: tax.code,
			codeTable: tax.codeTable,
			codePercentage: tax.codePercentage,
			flagSales: Boolean(tax.flagSales),
			flagPurchases: Boolean(tax.flagPurchases)
		};
	}
	return newTaxes;
}

function routeName() {
	return this.$route.name;
}

function invalidPaymentMethod() {
	var wayPayment = this.getWayPayment.wayPayment;

	return wayPayment === 1 ? this.isVisaPayment : !wayPayment;
}

function data() {
	return {
		discount: 0
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'purchase-summary',
	components: {
		shippingCost: function shippingCost() {
			return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 990));
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['billingData', 'deliveryAddress', 'flagPickUp', 'getClientDiscount', 'getCurrencySymbol', 'getNewAddressData', 'getCommerceData', 'getResponsibleData', 'getTotalAmount', 'getUserInfo', 'getWayPayment', 'invalidOrder', 'isVisaPayment', 'orderSummaryInfo', 'productsSelected', 'totalProducts', 'shippingCostAmount', 'shippingCostObject', 'token', 'warehouse']), {
		customerAddressId: customerAddressId,
		getBillindData: getBillindData,
		getWarehouseAddress: getWarehouseAddress,
		getWarehouseId: getWarehouseId,
		getWarehouseName: getWarehouseName,
		invalidPaymentMethod: invalidPaymentMethod,
		routeName: routeName,
		total: total
	}),
	data: data,
	methods: {
		buildBody: buildBody,
		getDetails: getDetails,
		getOrderDetails: getOrderDetails,
		makeOrder: makeOrder,
		payAction: payAction,
		setTaxes: setTaxes
	}
});

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(414)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans/OpenSans-Regular.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans/OpenSans-Bold.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans/OpenSans-SemiBold.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans/OpenSans-Light.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirMedium;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}.absolute[data-v-06fe9f96]{position:absolute}.align-center[data-v-06fe9f96]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.align-start[data-v-06fe9f96]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.align-end[data-v-06fe9f96]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.bgWhite[data-v-06fe9f96]{background-color:#fff}.black[data-v-06fe9f96]{color:#e9d628}.block[data-v-06fe9f96]{display:block}.bold[data-v-06fe9f96]{font-weight:700}.d-flex[data-v-06fe9f96]{display:-webkit-box;display:-ms-flexbox;display:flex}.disabled-btn[data-v-06fe9f96]{cursor:not-allowed;opacity:.25}.flex-column[data-v-06fe9f96]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.flex-5[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 5%;flex:1 1 5%}.flex-10[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 10%;flex:1 1 10%}.flex-15[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 15%;flex:1 1 15%}.flex-25[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 25%;flex:1 1 25%}.flex-20[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 20%;flex:1 1 20%}.flex-30[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 30%;flex:1 1 30%}.flex-40[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 40%;flex:1 1 40%}.flex-45[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 45%;flex:1 1 45%}.flex-50[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}.flex-60[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 60%;flex:1 1 60%}.flex-65[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 65%;flex:1 1 65%}.flex-70[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 70%;flex:1 1 70%}.flex-80[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 80%;flex:1 1 80%}.flex-95[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 95%;flex:1 1 95%}.flex-auto[data-v-06fe9f96]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.fontAvenir[data-v-06fe9f96]{font-family:AvenirMedium}.fontAvenirBold[data-v-06fe9f96]{font-family:AvenirBold}.fontOpenBold[data-v-06fe9f96]{font-family:Opens_semibold}.fontAvenirDemi[data-v-06fe9f96]{font-family:AvenirDemi}.fontS10[data-v-06fe9f96]{font-size:1rem}.fontS11[data-v-06fe9f96]{font-size:1.1rem}.fontS12[data-v-06fe9f96]{font-size:1.2rem}.fontS13[data-v-06fe9f96]{font-size:1.3rem}.fontS14[data-v-06fe9f96]{font-size:1.4rem}.fontS16[data-v-06fe9f96]{font-size:1.6rem}.fontS20[data-v-06fe9f96]{font-size:2rem}.h-100[data-v-06fe9f96]{height:100%}.justify-center[data-v-06fe9f96]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-end[data-v-06fe9f96]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.justify-start[data-v-06fe9f96]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-text[data-v-06fe9f96]{text-align:justify}.line-height-2[data-v-06fe9f96]{line-height:2rem}.m0[data-v-06fe9f96]{margin:0}.m-auto[data-v-06fe9f96]{margin:auto}.mb-1[data-v-06fe9f96]{margin-bottom:1rem}.mb-2[data-v-06fe9f96]{margin-bottom:2rem}.mb-3[data-v-06fe9f96]{margin-bottom:3rem}.mb-4[data-v-06fe9f96]{margin-bottom:4rem}.mb-6[data-v-06fe9f96]{margin-bottom:6rem}.mr-1[data-v-06fe9f96]{margin-right:1rem}.mr-2[data-v-06fe9f96]{margin-right:2rem}.mr-3[data-v-06fe9f96]{margin-right:3rem}.mx-1[data-v-06fe9f96]{margin-left:1rem;margin-right:1rem}.mx-2[data-v-06fe9f96]{margin-left:2rem;margin-right:2rem}.mx-3[data-v-06fe9f96]{margin-left:3rem;margin-right:3rem}.my-0[data-v-06fe9f96]{margin-bottom:0;margin-top:0}.my-1[data-v-06fe9f96]{margin-bottom:1rem;margin-top:1rem}.my-2[data-v-06fe9f96]{margin-bottom:2rem;margin-top:2rem}.my-3[data-v-06fe9f96]{margin-bottom:3rem;margin-top:3rem}.my-4[data-v-06fe9f96]{margin-bottom:4rem;margin-top:4rem}.mt-1[data-v-06fe9f96]{margin-top:1rem}.mt-2[data-v-06fe9f96]{margin-top:2rem}.mt-3[data-v-06fe9f96]{margin-top:3rem}.mt-4[data-v-06fe9f96]{margin-top:4rem}.mt-5[data-v-06fe9f96]{margin-top:5rem}.ml-1[data-v-06fe9f96]{margin-left:1rem}.ml-2[data-v-06fe9f96]{margin-left:2rem}.ml-3[data-v-06fe9f96]{margin-left:3rem}.mw-100[data-v-06fe9f96]{min-width:100%}.orange[data-v-06fe9f96]{color:#f703ff}.pb-1[data-v-06fe9f96]{padding-bottom:1rem}.pb-2[data-v-06fe9f96]{padding-bottom:2rem}.pb-3[data-v-06fe9f96]{padding-bottom:3rem}.pt-2[data-v-06fe9f96]{padding-top:2rem}.pt-3[data-v-06fe9f96]{padding-top:3rem}.pt-4[data-v-06fe9f96]{padding-top:4rem}.px-1[data-v-06fe9f96]{padding:0 1rem}.px-2[data-v-06fe9f96]{padding:0 2rem}.px-3[data-v-06fe9f96]{padding-left:3rem;padding-right:3rem}.px-4[data-v-06fe9f96]{padding:0 4rem}.px-5[data-v-06fe9f96]{padding-left:5rem;padding-right:5rem}.px-8[data-v-06fe9f96]{padding-left:8rem;padding-right:8rem}.py-1[data-v-06fe9f96]{padding:1rem 0}.py-2[data-v-06fe9f96]{padding-top:2rem;padding-bottom:2rem}.py-3[data-v-06fe9f96]{padding-top:3rem;padding-bottom:3rem}.py-4[data-v-06fe9f96]{padding-top:4rem;padding-bottom:4rem}.p2[data-v-06fe9f96]{padding:2rem}.p4[data-v-06fe9f96]{padding:4rem}.p6[data-v-06fe9f96]{padding:6rem}.relative[data-v-06fe9f96]{position:relative}.space-around[data-v-06fe9f96]{-ms-flex-pack:distribute;justify-content:space-around}.space-evenly[data-v-06fe9f96]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.space-between[data-v-06fe9f96]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.txt-center[data-v-06fe9f96]{text-align:center}.txt-left[data-v-06fe9f96]{text-align:left}.txt-right[data-v-06fe9f96]{text-align:right}.uppercase[data-v-06fe9f96]{text-transform:uppercase}.w-100[data-v-06fe9f96]{width:100%}.w-51[data-v-06fe9f96]{width:51%}.white-space[data-v-06fe9f96]{white-space:nowrap}.wrap[data-v-06fe9f96]{-ms-flex-wrap:wrap;flex-wrap:wrap}button[data-v-06fe9f96],div[data-v-06fe9f96],input[data-v-06fe9f96]{font-family:Opens_bold}.border[data-v-06fe9f96]{border-bottom:.1rem solid #e1dddd}.container-summary[data-v-06fe9f96]{margin:2.2rem 0 0}@media (max-width:768px){.container-summary[data-v-06fe9f96]{margin:2rem 0 0}}.wrapper-summary[data-v-06fe9f96]{background-color:#f7f7f7;position:-webkit-sticky;position:sticky;min-width:25rem;top:12%}@media (max-width:500px){.wrapper-summary[data-v-06fe9f96]{padding:0 2.5rem}}.title-summary[data-v-06fe9f96]{border-bottom:.1rem solid #e1dddd;font-family:Opens_bold;font-size:1.6rem;margin:0;padding:3rem .8rem .5rem;text-align:center}.input[data-v-06fe9f96]{border:none;border-radius:.8rem}.btn-apli[data-v-06fe9f96]{background-color:#7b7b7b}.container-price[data-v-06fe9f96]{color:#676767;margin-bottom:1rem}.price-subtotal[data-v-06fe9f96]{margin-bottom:0}.price-discount[data-v-06fe9f96]{font-family:Opens_regular;margin:0}.btn-discount[data-v-06fe9f96]{background-color:#7b7b7b;border:.1rem solid #9a9a9a;border-bottom-right-radius:.8rem;border-top-right-radius:.8rem;color:#ffff;height:3.3rem;min-width:8rem}.input-descuent[data-v-06fe9f96]{background-color:#ffff;border:.1rem solid #e1dddd;border-bottom-left-radius:.8rem;border-top-left-radius:.8rem;color:#c2c2c2;padding-left:.8rem}.flex-center[data-v-06fe9f96]{padding:1.2rem}.btn-box[data-v-06fe9f96]{border-radius:.8rem;color:#ffff;margin-bottom:2.2rem;outline:none;padding:.8rem;min-width:24rem}.btn-back[data-v-06fe9f96],.btn-order[data-v-06fe9f96]{background-color:#7b7b7b;border-radius:.8rem;color:#fff;min-width:11rem;padding:.8rem}.btn-order[data-v-06fe9f96]{background-color:#f703ff}.warehouse[data-v-06fe9f96]{font-size:1.4rem;margin:1rem 0 0}.store-dispatch[data-v-06fe9f96]{background-color:#f1f1f1;border-bottom:.1rem solid #e1dddd}.btn-disabled[data-v-06fe9f96]{background-color:#ccc;opacity:.5}@media (max-width:500px){.btn-responsive[data-v-06fe9f96]{height:4.5rem}}.price-delivery-amount[data-v-06fe9f96],.price-delivery-txt[data-v-06fe9f96]{margin:0}.discount-amount[data-v-06fe9f96]{font-family:Opens_regular}", "", {"version":3,"sources":["/opt/build/repo/src/components/purchaseSummary.vue"],"names":[],"mappings":"AACA,WACE,0BAA6B,AAC7B,uDAAwD,AACxD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,oDAAqD,AACrD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,wDAAyD,AACzD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,qDAAsD,AACtD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,yBAA4B,AAC5B,6DAA8D,AAC9D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,0DAA2D,AAC3D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,0DAA2D,AAC3D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,2BACE,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,8BACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,4BACE,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CAC/B,AACD,0BACE,qBAAwB,CACzB,AACD,wBACE,aAAe,CAChB,AACD,wBACE,aAAe,CAChB,AACD,uBACE,eAAkB,CACnB,AACD,yBACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,+BACE,mBAAoB,AACpB,WAAc,CACf,AACD,8BACE,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,yBACE,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACtB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,4BACE,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CACxB,AACD,6BACE,wBAA4B,CAC7B,AACD,iCACE,sBAA0B,CAC3B,AACD,+BACE,0BAA8B,CAC/B,AACD,iCACE,sBAA0B,CAC3B,AACD,0BACE,cAAgB,CACjB,AACD,0BACE,gBAAkB,CACnB,AAID,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,cAAgB,CACjB,AACD,wBACE,WAAa,CACd,AACD,iCACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,8BACE,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,gCACE,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACrC,AACD,+BACE,kBAAoB,CACrB,AACD,gCACE,gBAAkB,CACnB,AACD,qBACE,QAAU,CACX,AACD,yBACE,WAAa,CACd,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,gBAAiB,AACjB,YAAc,CACf,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,yBACE,cAAgB,CACjB,AACD,yBACE,aAAe,CAChB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,qBACE,YAAc,CACf,AACD,qBACE,YAAc,CACf,AACD,qBACE,YAAc,CACf,AACD,2BACE,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,4BAA8B,CACnC,AACD,+BACE,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CACvC,AACD,gCACE,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,6BACE,iBAAmB,CACpB,AACD,2BACE,eAAiB,CAClB,AACD,4BACE,gBAAkB,CACnB,AACD,4BACE,wBAA0B,CAC3B,AACD,wBACE,UAAY,CACb,AACD,uBACE,SAAW,CACZ,AACD,8BACE,kBAAoB,CACrB,AACD,uBACE,mBAAoB,AAChB,cAAgB,CACrB,AACD,oEACE,sBAA0B,CAC3B,AACD,yBACE,iCAAoC,CACrC,AACD,oCACE,iBAAmB,CACpB,AACD,yBACA,oCACM,eAAiB,CACtB,CACA,AACD,kCACE,yBAA0B,AAC1B,wBAAyB,AACzB,gBAAiB,AACjB,gBAAiB,AACjB,OAAS,CACV,AACD,yBACA,kCACM,gBAAkB,CACvB,CACA,AACD,gCACE,kCAAoC,AACpC,uBAA0B,AAC1B,iBAAkB,AAClB,SAAU,AACV,yBAA4B,AAC5B,iBAAmB,CACpB,AACD,wBACE,YAAa,AACb,mBAAsB,CACvB,AACD,2BACE,wBAA0B,CAC3B,AACD,kCACE,cAAe,AACf,kBAAoB,CACrB,AACD,iCACE,eAAiB,CAClB,AACD,iCACE,0BAA6B,AAC7B,QAAU,CACX,AACD,+BACE,yBAA0B,AAC1B,2BAA6B,AAC7B,iCAAmC,AACnC,8BAAgC,AAChC,YAAa,AACb,cAAe,AACf,cAAgB,CACjB,AACD,iCACE,uBAAwB,AACxB,2BAA6B,AAC7B,gCAAkC,AAClC,6BAA+B,AAC/B,cAAe,AACf,kBAAqB,CACtB,AACD,8BACE,cAAgB,CACjB,AACD,0BACE,oBAAsB,AACtB,YAAa,AACb,qBAAsB,AACtB,aAAc,AACd,cAAgB,AAChB,eAAiB,CAClB,AACD,uDAEE,yBAA0B,AAC1B,oBAAsB,AACtB,WAAa,AACb,gBAAiB,AACjB,aAAgB,CACjB,AACD,4BACE,wBAA0B,CAC3B,AACD,4BACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,iCACE,yBAA0B,AAC1B,iCAAoC,CACrC,AACD,+BACE,sBAA0B,AAC1B,UAAa,CACd,AACD,yBACA,iCACI,aAAe,CAClB,CACA,AACD,6EAEE,QAAU,CACX,AACD,kCACE,yBAA6B,CAC9B","file":"purchaseSummary.vue","sourcesContent":["\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirMedium';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirBold';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirDemi';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n.absolute[data-v-06fe9f96] {\n  position: absolute;\n}\n.align-center[data-v-06fe9f96] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.align-start[data-v-06fe9f96] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.align-end[data-v-06fe9f96] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.bgWhite[data-v-06fe9f96] {\n  background-color: white;\n}\n.black[data-v-06fe9f96] {\n  color: #e9d628;\n}\n.block[data-v-06fe9f96] {\n  display: block;\n}\n.bold[data-v-06fe9f96] {\n  font-weight: bold;\n}\n.d-flex[data-v-06fe9f96] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.disabled-btn[data-v-06fe9f96] {\n  cursor: not-allowed;\n  opacity: 0.25;\n}\n.flex-column[data-v-06fe9f96] {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.flex-5[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 5%;\n          flex: 1 1 5%;\n}\n.flex-10[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 10%;\n          flex: 1 1 10%;\n}\n.flex-15[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 15%;\n          flex: 1 1 15%;\n}\n.flex-25[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 25%;\n          flex: 1 1 25%;\n}\n.flex-20[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 20%;\n          flex: 1 1 20%;\n}\n.flex-30[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 30%;\n          flex: 1 1 30%;\n}\n.flex-40[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 40%;\n          flex: 1 1 40%;\n}\n.flex-45[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 45%;\n          flex: 1 1 45%;\n}\n.flex-50[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 50%;\n          flex: 1 1 50%;\n}\n.flex-60[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 60%;\n          flex: 1 1 60%;\n}\n.flex-65[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 65%;\n          flex: 1 1 65%;\n}\n.flex-70[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 70%;\n          flex: 1 1 70%;\n}\n.flex-80[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 80%;\n          flex: 1 1 80%;\n}\n.flex-95[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 95%;\n          flex: 1 1 95%;\n}\n.flex-auto[data-v-06fe9f96] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n.fontAvenir[data-v-06fe9f96] {\n  font-family: \"AvenirMedium\";\n}\n.fontAvenirBold[data-v-06fe9f96] {\n  font-family: \"AvenirBold\";\n}\n.fontOpenBold[data-v-06fe9f96] {\n  font-family: \"Opens_semibold\";\n}\n.fontAvenirDemi[data-v-06fe9f96] {\n  font-family: \"AvenirDemi\";\n}\n.fontS10[data-v-06fe9f96] {\n  font-size: 1rem;\n}\n.fontS11[data-v-06fe9f96] {\n  font-size: 1.1rem;\n}\n.fontS13[data-v-06fe9f96] {\n  font-size: 1.3rem;\n}\n.fontS12[data-v-06fe9f96] {\n  font-size: 1.2rem;\n}\n.fontS13[data-v-06fe9f96] {\n  font-size: 1.3rem;\n}\n.fontS14[data-v-06fe9f96] {\n  font-size: 1.4rem;\n}\n.fontS16[data-v-06fe9f96] {\n  font-size: 1.6rem;\n}\n.fontS20[data-v-06fe9f96] {\n  font-size: 2rem;\n}\n.h-100[data-v-06fe9f96] {\n  height: 100%;\n}\n.justify-center[data-v-06fe9f96] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.justify-end[data-v-06fe9f96] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.justify-start[data-v-06fe9f96] {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.justify-text[data-v-06fe9f96] {\n  text-align: justify;\n}\n.line-height-2[data-v-06fe9f96] {\n  line-height: 2rem;\n}\n.m0[data-v-06fe9f96] {\n  margin: 0;\n}\n.m-auto[data-v-06fe9f96] {\n  margin: auto;\n}\n.mb-1[data-v-06fe9f96] {\n  margin-bottom: 1rem;\n}\n.mb-2[data-v-06fe9f96] {\n  margin-bottom: 2rem;\n}\n.mb-3[data-v-06fe9f96] {\n  margin-bottom: 3rem;\n}\n.mb-4[data-v-06fe9f96] {\n  margin-bottom: 4rem;\n}\n.mb-6[data-v-06fe9f96] {\n  margin-bottom: 6rem;\n}\n.mr-1[data-v-06fe9f96] {\n  margin-right: 1rem;\n}\n.mr-2[data-v-06fe9f96] {\n  margin-right: 2rem;\n}\n.mr-3[data-v-06fe9f96] {\n  margin-right: 3rem;\n}\n.mx-1[data-v-06fe9f96] {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.mx-2[data-v-06fe9f96] {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.mx-3[data-v-06fe9f96] {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.my-0[data-v-06fe9f96] {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.my-1[data-v-06fe9f96] {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n.my-2[data-v-06fe9f96] {\n  margin-bottom: 2rem;\n  margin-top: 2rem;\n}\n.my-3[data-v-06fe9f96] {\n  margin-bottom: 3rem;\n  margin-top: 3rem;\n}\n.my-4[data-v-06fe9f96] {\n  margin-bottom: 4rem;\n  margin-top: 4rem;\n}\n.mt-1[data-v-06fe9f96] {\n  margin-top: 1rem;\n}\n.mt-2[data-v-06fe9f96] {\n  margin-top: 2rem;\n}\n.mt-3[data-v-06fe9f96] {\n  margin-top: 3rem;\n}\n.mt-4[data-v-06fe9f96] {\n  margin-top: 4rem;\n}\n.mt-5[data-v-06fe9f96] {\n  margin-top: 5rem;\n}\n.ml-1[data-v-06fe9f96] {\n  margin-left: 1rem;\n}\n.ml-2[data-v-06fe9f96] {\n  margin-left: 2rem;\n}\n.ml-3[data-v-06fe9f96] {\n  margin-left: 3rem;\n}\n.mw-100[data-v-06fe9f96] {\n  min-width: 100%;\n}\n.orange[data-v-06fe9f96] {\n  color: #f703ff;\n}\n.pb-1[data-v-06fe9f96] {\n  padding-bottom: 1rem;\n}\n.pb-2[data-v-06fe9f96] {\n  padding-bottom: 2rem;\n}\n.pb-3[data-v-06fe9f96] {\n  padding-bottom: 3rem;\n}\n.pt-2[data-v-06fe9f96] {\n  padding-top: 2rem;\n}\n.pt-3[data-v-06fe9f96] {\n  padding-top: 3rem;\n}\n.pt-4[data-v-06fe9f96] {\n  padding-top: 4rem;\n}\n.px-1[data-v-06fe9f96] {\n  padding: 0 1rem;\n}\n.px-2[data-v-06fe9f96] {\n  padding: 0 2rem;\n}\n.px-3[data-v-06fe9f96] {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.px-4[data-v-06fe9f96] {\n  padding: 0 4rem;\n}\n.px-5[data-v-06fe9f96] {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n.px-8[data-v-06fe9f96] {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.py-1[data-v-06fe9f96] {\n  padding: 1rem 0;\n}\n.py-2[data-v-06fe9f96] {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.py-3[data-v-06fe9f96] {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.py-4[data-v-06fe9f96] {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.p2[data-v-06fe9f96] {\n  padding: 2rem;\n}\n.p4[data-v-06fe9f96] {\n  padding: 4rem;\n}\n.p6[data-v-06fe9f96] {\n  padding: 6rem;\n}\n.relative[data-v-06fe9f96] {\n  position: relative;\n}\n.space-around[data-v-06fe9f96] {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.space-evenly[data-v-06fe9f96] {\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n}\n.space-between[data-v-06fe9f96] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.txt-center[data-v-06fe9f96] {\n  text-align: center;\n}\n.txt-left[data-v-06fe9f96] {\n  text-align: left;\n}\n.txt-right[data-v-06fe9f96] {\n  text-align: right;\n}\n.uppercase[data-v-06fe9f96] {\n  text-transform: uppercase;\n}\n.w-100[data-v-06fe9f96] {\n  width: 100%;\n}\n.w-51[data-v-06fe9f96] {\n  width: 51%;\n}\n.white-space[data-v-06fe9f96] {\n  white-space: nowrap;\n}\n.wrap[data-v-06fe9f96] {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\ndiv[data-v-06fe9f96], input[data-v-06fe9f96], button[data-v-06fe9f96] {\n  font-family: \"Opens_bold\";\n}\n.border[data-v-06fe9f96] {\n  border-bottom: 0.1rem solid #e1dddd;\n}\n.container-summary[data-v-06fe9f96] {\n  margin: 2.2rem 0 0;\n}\n@media (max-width: 768px) {\n.container-summary[data-v-06fe9f96] {\n      margin: 2rem 0 0;\n}\n}\n.wrapper-summary[data-v-06fe9f96] {\n  background-color: #f7f7f7;\n  position: -webkit-sticky;\n  position: sticky;\n  min-width: 25rem;\n  top: 12%;\n}\n@media (max-width: 500px) {\n.wrapper-summary[data-v-06fe9f96] {\n      padding: 0 2.5rem;\n}\n}\n.title-summary[data-v-06fe9f96] {\n  border-bottom: 0.1rem solid #e1dddd;\n  font-family: \"Opens_bold\";\n  font-size: 1.6rem;\n  margin: 0;\n  padding: 3rem 0.8rem 0.5rem;\n  text-align: center;\n}\n.input[data-v-06fe9f96] {\n  border: none;\n  border-radius: 0.8rem;\n}\n.btn-apli[data-v-06fe9f96] {\n  background-color: #7b7b7b;\n}\n.container-price[data-v-06fe9f96] {\n  color: #676767;\n  margin-bottom: 1rem;\n}\n.price-subtotal[data-v-06fe9f96] {\n  margin-bottom: 0;\n}\n.price-discount[data-v-06fe9f96] {\n  font-family: \"Opens_regular\";\n  margin: 0;\n}\n.btn-discount[data-v-06fe9f96] {\n  background-color: #7b7b7b;\n  border: solid 0.1rem #9a9a9a;\n  border-bottom-right-radius: 0.8rem;\n  border-top-right-radius: 0.8rem;\n  color: #ffff;\n  height: 3.3rem;\n  min-width: 8rem;\n}\n.input-descuent[data-v-06fe9f96] {\n  background-color: #ffff;\n  border: 0.1rem solid #e1dddd;\n  border-bottom-left-radius: 0.8rem;\n  border-top-left-radius: 0.8rem;\n  color: #c2c2c2;\n  padding-left: 0.8rem;\n}\n.flex-center[data-v-06fe9f96] {\n  padding: 1.2rem;\n}\n.btn-box[data-v-06fe9f96] {\n  border-radius: 0.8rem;\n  color: #ffff;\n  margin-bottom: 2.2rem;\n  outline: none;\n  padding: 0.8rem;\n  min-width: 24rem;\n}\n.btn-order[data-v-06fe9f96],\n.btn-back[data-v-06fe9f96] {\n  background-color: #7b7b7b;\n  border-radius: 0.8rem;\n  color: white;\n  min-width: 11rem;\n  padding: 0.8rem;\n}\n.btn-order[data-v-06fe9f96] {\n  background-color: #f703ff;\n}\n.warehouse[data-v-06fe9f96] {\n  font-size: 1.4rem;\n  margin: 1rem 0 0;\n}\n.store-dispatch[data-v-06fe9f96] {\n  background-color: #f1f1f1;\n  border-bottom: 0.1rem solid #e1dddd;\n}\n.btn-disabled[data-v-06fe9f96] {\n  background-color: #cccccc;\n  opacity: 0.5;\n}\n@media (max-width: 500px) {\n.btn-responsive[data-v-06fe9f96] {\n    height: 4.5rem;\n}\n}\n.price-delivery-txt[data-v-06fe9f96],\n.price-delivery-amount[data-v-06fe9f96] {\n  margin: 0;\n}\n.discount-amount[data-v-06fe9f96] {\n  font-family: \"Opens_regular\";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(825);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(415)("1fa9d304", content, true);

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.0c9e2779488973bf29ff.js